<template>
  <div class="email-form">
    <Attention v-if="errorMessage" :text="errorMessage"/>
    <form
      name="form"
      ref="form"
      :action="action"
      method="post"
      novalidate
      @submit.prevent="handleSubmit()"
    >
      <input type="hidden" name="_token" :value="csrfToken">
      <input type="hidden" name="reissue_key" :value="reissueKey">
      <div class="email-form__body">
        <form-password
          name="password"
          v-model="password"
          label="新しいパスワード"
          :validation="{ rules: {
            required: true,
            max: 30,
            min: 8,
            passCheck2: true,
            passCheck1: true,
            confirmed: password
          } }"
        ></form-password>

        <form-password
          name="re_password"
          v-model="re_password"
          label="新しいパスワード(確認)"
          :validation="{ rules: {
            required: true,
            max: 30,
            min: 8,
            passCheck2: true,
            passCheck1: true,
            confirmed: password
          } }"
        >
          <p class="email-form__sub-text">※半角英字・数字の組み合わせ8~30文字（記号も可）</p>
        </form-password>
      </div>

      <div class="email-form__foot">
        <SubmitButton
          type="submit"
          text="設定"
          :disabled="password === '' || re_password === '' || errors.items.length !== 0"
        />
      </div>

    </form>
  </div>
</template>

<script>
import Attention from '../common/Attention'
import SubmitButton from '../partials/SubmitButton'

export default {
  name: 'ReissuePasswordForm',
  components: {
    Attention,
    SubmitButton
  },
  props: {
    action: String,
    reissueKey: String
  },
  data () {
    return {
      password: '',
      re_password: '',
      csrfToken: window.Laravel.csrfToken,
      errorMessage: ''
    }
  },
  methods: {
    handleSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$refs.form.submit()
        } else {
          this.errorMessage = this.formErrors[0].msg
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../sass/commons/commonVariables.scss';

.email-form {
  padding: 35px 4px 20px;
  &__body {
    padding: 0 10px;
    margin: 0 0 30px;
  }
  &__sub-text {
    font-size: 11px;
    margin: 8px 0 0;
  }
  &__foot {
    padding: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/User/ReissuePasswordForm.vue